


































import { Component, Prop, Vue } from 'vue-property-decorator'

import AppFilterButton from '@/components/AppFilterButton.vue'

@Component({
  components: {
    AppFilterButton
  }
})
export default class extends Vue {
  @Prop(Array) readonly tabs!: { id: string; name: string }[]
  @Prop(Array) readonly categories: { id: string; name: string }[] | undefined
  @Prop(String) readonly tabId!: string;
  @Prop() readonly categoryId!: string | (string | null)[] | null;
  @Prop(Boolean) readonly filter!: boolean

  get categoryIdChecked () {
    if (!this.categoryId) return ''
    if (this.categoryId.length) {
      if (Array.isArray(this.categoryId)) {
        return this.categoryId[0] || ''
      }
      return this.categoryId
    }
    return ''
  }
}
